import React from 'react';
import { FiGrid, FiUser, FiFolder, FiBarChart2, FiFileText, FiLogOut, FiChevronLeft, FiMonitor } from 'react-icons/fi';
import { Link, withRouter } from 'react-router-dom';
import { cn } from '../utils/cn';
import logo from '../assets/images/SATI/IBi-logo.png';

function SidebarItem({ icon: Icon, label, active, to, onClick }) {
    const content = (
        <div className={cn(
            "flex items-center gap-3 w-full px-6 py-4 transition-colors",
            active ? "bg-brand-navy text-white" : "text-brand-gray-dark hover:bg-gray-50"
        )}>
            <Icon className="w-6 h-6" />
            <span className="font-medium text-base">{label}</span>
            {active && <div className="ml-auto w-1 h-1 rounded-full bg-brand-blue" />}
        </div>
    );

    return to ? <Link to={to} className="block">{content}</Link> : <button onClick={onClick} className="w-full text-left">{content}</button>;
}

export function Sidebar({ onClose, location }) {
    const pathname = location.pathname;
    const isCompanyRole = Number(sessionStorage.getItem('satiRol')) === 2;
    const canViewMonthlyChallenges =
        sessionStorage.getItem("satiRol") === "1" &&
        sessionStorage.getItem("empresaId") === "1";

    return (
        <aside className="w-64 h-full bg-white rounded-[2rem] shadow-xl flex flex-col overflow-hidden border border-brand-gray-light/20 relative">
            <div className="p-8 pb-4 flex flex-col items-center relative">
                <button onClick={onClose} className="absolute top-4 right-4 p-2 text-brand-gray-dark hover:text-brand-navy hover:bg-gray-100 rounded-full transition-colors">
                    <FiChevronLeft className="w-5 h-5" />
                </button>
                <img src={logo} alt="IBICARE" className="w-12 h-12 mb-2 object-contain" />
                <h2 className="text-2xl font-bold text-brand-navy tracking-tight">IBICARE</h2>
            </div>

            <nav className="flex-1 mt-6">
                <SidebarItem icon={FiUser} label="Perfil" to="/profile" active={pathname === "/profile"} />
                <SidebarItem icon={FiGrid} label="Registro" to="/dashboard" active={pathname === "/dashboard"} />
                {isCompanyRole && (
                    <SidebarItem icon={FiMonitor} label="KIOSK" to="/kiosk" active={pathname === "/kiosk"} />
                )}
                {/* 
                <SidebarItem icon={FiFolder} label="Contenido" to="/contents" active={pathname === "/contents"} />
                <SidebarItem icon={FiBarChart2} label="Ranking" to="/ranking/steps" active={pathname.includes("ranking")} />
                */}
                {canViewMonthlyChallenges && (
                <SidebarItem icon={FiFileText} label="Retos mensuales" to="/monthly-challenges" active={pathname === "/monthly-challenges"} />
                )}
            </nav>

            <div className="bg-brand-navy p-6 mt-auto rounded-b-[2rem]">
                <Link to="/logout" className="flex items-center gap-3 text-white/80 hover:text-white transition-colors">
                    <FiLogOut className="w-5 h-5" />
                    <span className="text-sm font-medium uppercase tracking-wider">Cerrar sesión</span>
                </Link>
            </div>
        </aside>
    );
}

export default withRouter(Sidebar);
